/**
 * 手势缩放
 * 2020/09/03 by ylm
 * */
import utils from "../utils"

export default(Vue) => {
  Vue.directive('touch', {
    bind: function (el, binding, vnode) {
      let type = binding.arg  // 传入点击的类型

      // 勾股定理计算距离
      function getDistance(bg, end){
        return Math.sqrt(Math.pow((end.x - bg.x),2 ) + Math.pow((end.y - bg.y),2 ));
      }


      // 获取用户指屏幕的像素的位置 (兼容PC和移动端)
      let getPointingPos = (event) => {

        let pointingPos = {x: event.clientX, y: event.clientY}    // PC端 被点击像素点位置

        // 如果是移动端就获取移动端点的位置
        if(['ios', 'android'].includes(utils.getEnv())){
          if(event.touches[0]){
            pointingPos.x = event.touches[0].clientX
            pointingPos.y = event.touches[0].clientY
          }else if(event.changedTouches[0]){
            pointingPos.x = event.changedTouches[0].clientX
            pointingPos.y = event.changedTouches[0].clientY
          }
        }
        return pointingPos
      }

      // 2个手指
      let getPointingPos2 = event => {
        let pos, pos2

        // 如果是移动端就获取移动端点的位置
        if(['ios', 'android'].includes(utils.getEnv())){
          if(event.touches[0] && event.touches[1]){
            pos = {
              x: event.touches[0].clientX,
              y: event.touches[0].clientY
            }
            pos2= {
              x: event.touches[1].clientX,
              y: event.touches[1].clientY
            }
          }else if(event.changedTouches[0] && event.changedTouches[1]){
            pos = {
              x: event.changedTouches[0].clientX,
              y: event.changedTouches[0].clientY
            }
            pos2 = {
              x: event.changedTouches[1].clientX,
              y: event.changedTouches[1].clientY
            }
          }
        }

        if(pos2) return { pos, pos2 }
      }


      let grossMenuMove
      let element = $(el)
      let bgDis



      // 鼠标离开/放开时
      let grossMouseUp = e => {
        bgDis = undefined
        $(document).off('touchmove', grossMenuMove)
        $(document).off('touchend', grossMouseUp)
        // $(document).off('mouseleave', grossMouseUp)
        clearMoveListen()
      }




      // 关闭拖动 清除移动监听
      let clearMoveListen = () => {
        element.off()
        // handle.off()
        // setTimeout(function(){element.css({'left':'50%', 'top':'50%'})},250)
      }




      // 点击开始的时候
      el.addEventListener('touchstart', function(e){

        e.preventDefault()

        let downPx = getPointingPos(e)

        // 位置
        let prePx = {
          x: +element.css('left').slice(0, element.css('left').length-2),
          y: +element.css('top').slice(0, element.css('top').length-2)
        }
        let dis = {
          x:  prePx.x - downPx.x,
          y:  prePx.y - downPx.y
        }

        // 缩放
        let preScale = {
          x: +element.width()
        }

        // 鼠标移动时
        grossMenuMove = function (e) {
          // e.preventDefault()
          let px = getPointingPos(e)
          let px2 = getPointingPos2(e)
          if(!bgDis && px2) bgDis = getDistance(px2.pos, px2.pos2)

          // 有两个手指移动时放大，一个手指移动时移动
          if(px2){
            let nowDis = getDistance(px2.pos, px2.pos2)
            preScale.x += (nowDis - bgDis) / (devicePixelRatio*2)
            if(preScale.x > 200) element.css({'width': preScale.x+'px'})
          }else{
            element.css({'left':px.x+dis.x+'px', 'top':px.y+dis.y+'px'})
          }

        }

        $(document).on('touchmove', grossMenuMove)

        $(document).on('touchend', grossMouseUp)

      }, false)


      /*el.addEventListener('touchmove', function(e){

        // e.preventDefault()



      }, false)*/


     /* el.addEventListener('touchend', function(e){

        e.preventDefault()

        // 清除移动监听
        clearMoveListen()

      }, false)*/
    }
  })
}
